import { Dari } from '../../../../classes/model'
import { cover } from '../../../../utility/constant/helper.constant'

/**
 * The offset for the most outer support logs (startPosition - logBarOffset)
 * @returns Offset for the most outer support logs
 */
const logBarOffset = () => 0

/**
 * The height of the front bar
 * @returns Height of the front bar
 */
const frontHeight = (): number => {
  return Dari.frontHeight(
    cover.bar.angle,
    cover.terraceCover.depth,
    cover.terraceCover.height
  )
}

/**
 * The width of the top windows
 * @returns Width of the top windows
 */
const windowsTopWidth = (): number => {
  return Dari.windowsTopWidth(
    cover.terraceCover.width,
    cover.terraceCover.windowsTopTotal
  )
}

/**
 * The width of the front windows
 * @returns Width of the front windows
 */
const windowsFrontWidth = (): number => {
  return Dari.windowsFrontWidth(
    cover.terraceCover.width,
    cover.terraceCover.windowsFrontTotal
  )
}

/**
 * The width of the side windows
 * @returns Width of the side windows
 */
const windowsSideWidth = (): number => {
  return Dari.windowsSideWidth(
    cover.terraceCover.depth,
    cover.terraceCover.windowsSideTotal
  )
}

/**
 * The height to compensate that rotation takes place in the center of the mesh
 * @returns Height of the angleCompensation
 */
const angleCompensation = (): number => {
  return Dari.angleCompensation(cover.bar.angle, cover.terraceCover.depth)
}

/**
 * The amount of top window logs
 * @returns Total number of top window logs
 */
const logsTopTotal = (): number => {
  return Dari.logsTopTotal(cover.terraceCover.width)
}

/**
 * The amount of front window logs
 * @returns Total number of front window logs
 */
const logsFrontTotal = (): number => {
  return Dari.logsFrontTotal(cover.terraceCover.width)
}

/**
 * The amount of side window logs
 * @returns Total number of side window logs
 */
const logsSideTotal = (): number => {
  return Dari.logsSideTotal(cover.terraceCover.depth)
}

export const method = {
  logBarOffset,
  frontHeight,
  windowsTopWidth,
  windowsFrontWidth,
  windowsSideWidth,
  angleCompensation,
  logsTopTotal,
  logsFrontTotal,
  logsSideTotal,
}
